import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private lastUrl: string = '/';

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.lastUrl = event.urlAfterRedirects;
    });
  }

  getLastUrl(): string {
    return this.lastUrl;
  }

  isPublicPage(): boolean {
    if (this.lastUrl.includes('admin')) return false;
    const publicUrls = ['/public', '/posts', 'courses'];
    return publicUrls.some(url => this.lastUrl.includes(url));
  }
}
